import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as s, openBlock as l, normalizeClass as n, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSliders",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], h = ["clip-path"], u = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 1a.5.5 0 0 1 .5.5V5a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 2 1Zm.5 6.5H3a.5.5 0 1 0 0-1H1a.5.5 0 0 0 0 1h.5v3a.5.5 0 1 0 1 0v-3Zm4-1.5a.5.5 0 1 0-1 0v4.5a.5.5 0 1 0 1 0V6ZM6 1a.5.5 0 0 1 .5.5v2H7a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h.5v-2A.5.5 0 0 1 6 1Zm4 6.5h1a.5.5 0 1 1 0 1h-.5v2a.5.5 0 1 1-1 0v-2H9a.5.5 0 0 1 0-1h1ZM10 1a.5.5 0 0 1 .5.5V6a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 10 1Z",
  fill: "currentColor"
}, null, -1), m = [
  u
], f = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  p
];
function g(e, I, d, S, H, t) {
  return l(), s("svg", {
    "aria-label": d.ariaLabel,
    class: n([t.iconSizeClass, "d-icon d-icon--sliders"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Sliders",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, m, 8, h),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, _);
}
const V = /* @__PURE__ */ o(c, [["render", g]]);
export {
  V as default
};
//# sourceMappingURL=sliders.js.map
